import React from 'react'

export const PlaceLayout = React.lazy(() => import('./Place'));
export const OrderLayout = React.lazy(() => import('./Order'));
export const WaitingLayout = React.lazy(() => import('./Waiting'));
export const TicketingLayout = React.lazy(() => import('./Ticketing'));
export const MyTicketLayout = React.lazy(() => import('./My/Ticket'));